import { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from 'app/services/auth-services';

export const useApprovers = (params) => {
  const [approvers, setApprovers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(params?.numberIndex || 0);

  useEffect(() => {
    const fetchApprovers = async () => {
      // Don't fetch if params are not ready
      if (!params || !params.documentapprovalid) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);
      
      try {
        const response = await axios.get(
          `${BASE_URL}/Felix/DocumentapprovalCRUD/?Documentapproval_Id=${params?.documentapprovalid}`
        );
        setApprovers(response?.data?.Approve || []);
      } catch (error) {
        console.error('Error fetching approvers:', error);
        setError('Failed to load approvers. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchApprovers();
  }, [params?.documentapprovalid]);

  return { 
    approvers, 
    currentIndex, 
    setCurrentIndex,
    isLoading,
    error
  };
};